// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-bold[data-v-b63ff150] {\n  font-weight: 800;\n}", ""]);
// Exports
module.exports = exports;
